import { css } from '@emotion/css';
import { ColorConstant, Font } from 'src/styles';

export const select = (hasValue?: boolean) => css`
  ${Font.lg}
  color: ${ColorConstant.GRAY10};

  .ant-select-selection-placeholder {
    position: absolute;
    left: 11px;
    right: 11px;
    top: 0;
    bottom: 0;
  }

  .ant-select-clear {
    opacity: ${hasValue ? '1 !important' : '0 !important'};
    pointer-events: ${hasValue ? 'auto !important' : 'inherited'};
  }

  .ant-select-selection-item {
    position: absolute;
    inset: 0px 11px;
  }
`;
